import { render, staticRenderFns } from "./Founder.vue?vue&type=template&id=08990090&scoped=true"
import script from "./Founder.vue?vue&type=script&lang=js"
export * from "./Founder.vue?vue&type=script&lang=js"
import style0 from "./Founder.vue?vue&type=style&index=0&id=08990090&prod&scoped=true&lang=css"
import style1 from "./Founder.vue?vue&type=style&index=1&id=08990090&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08990090",
  null
  
)

export default component.exports